/**
 * Machine-readable reasons for a suggestion, so a screen can explain it without a score.
 *
 * Codes, never sentences. The UI turns each into one complete translated phrase — complete, because Arabic agreement makes a sentence assembled from translated fragments wrong in a way that is invisible to anyone reading only the English.
 */
export const ReasonCode = {
  FACE_LONGER_THAN_WIDE: 'FACE_LONGER_THAN_WIDE',
  FACE_CLEARLY_LONGER_THAN_WIDE: 'FACE_CLEARLY_LONGER_THAN_WIDE',
  FACE_AS_WIDE_AS_LONG: 'FACE_AS_WIDE_AS_LONG',
  STRAIGHT_SIDES: 'STRAIGHT_SIDES',
  CURVED_SIDES: 'CURVED_SIDES',
  ANGULAR_JAW: 'ANGULAR_JAW',
  SOFT_JAW: 'SOFT_JAW',
  WIDE_JAW: 'WIDE_JAW',
  NARROW_JAW: 'NARROW_JAW',
  WIDE_FOREHEAD: 'WIDE_FOREHEAD',
  NARROW_FOREHEAD: 'NARROW_FOREHEAD',
  FOREHEAD_BALANCED_WITH_CHEEKS: 'FOREHEAD_BALANCED_WITH_CHEEKS',
  WIDEST_AT_CHEEKBONES: 'WIDEST_AT_CHEEKBONES',
  WIDENS_TOWARDS_JAW: 'WIDENS_TOWARDS_JAW',
  NARROWS_TOWARDS_CHIN: 'NARROWS_TOWARDS_CHIN',
  POINTED_CHIN: 'POINTED_CHIN',
  BROAD_CHIN: 'BROAD_CHIN',
} as const;
export type ReasonCode = (typeof ReasonCode)[keyof typeof ReasonCode];
